import { filter } from 'lodash/fp';

const getSuggestions = ({ value, suggestions } = {}) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : filter((suggestion) => {
      const keep = count < 5
        && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

      if (keep) {
        count += 1;
      }

      return keep;
    }, suggestions);
};

export default getSuggestions;
